<template>
  <div class="about">
    <div class="md-layout md-alignment-center-center">
      <div
        class="md-layout-item md-xlarge-size-70 md-large-size-70 md-small-size-90 ql-editor articleContent"
        v-html="tool.content"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// @ is an alias to /src

export default {
  name: "toolbox",
  components: {},
  props: ["tool"],
  computed: {
    ...mapGetters(["getAllToolsBoxList"])
  }
};
</script>

<style >
.home {
}
</style>
